"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const ErrorPageSharedContent_1 = __importDefault(require("./ErrorPageSharedContent"));
const ErrorPage = () => {
    return (react_1.default.createElement(ErrorPageSharedContent_1.default, { bannerText: 'apptNotFoundBanner', type: 'warning', icon: '!' }));
};
exports.default = ErrorPage;
//# sourceMappingURL=ErrorPage.js.map